import { Grid, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AsyncLoadingButton from "../../components/asyncLoadingButton/AsyncLoadingButton";
import CancelButton from "../../components/cancelButton/CancelButton";
import type { ProviderFormState } from "./ProviderEdit";
import ProviderEdit from "./ProviderEdit";
import type { CreateOrUpdateProviderRequest } from "./providersApi";
import { useCreateProvider } from "./useCreateProvider";
import { useForm } from "react-hook-form";

const newProvider: () => ProviderFormState = () => ({
  name: "",
  contact: {
    phone: "",
    email: "",
  },
  contacts: [],
  contractNumber: "",
  info: "",
  termsAndConditions: "",
  description: { polish: "", english: "" },
  freeCancellationDays: null,
  productType: null,
  taxInfo: {
    taxNo: "",
    useForAllProducts: false,
    skipValidation: false,
  },
  participantListRequiredFields: {
    gender: true,
    dateOfBirth: true,
    citizenship: true,
    documentNumber: true,
    documentExpiryDate: true,
    exportDateFormat: "",
  },
  useDynamicPrices: false,
  currency: null,
  priceMargin: { multiplier: 1, amount: 0 },
  computePricesFromPurchasePrice: false,
});

const NewProviderPage = () => {
  const navigate = useNavigate();
  const { createProvider } = useCreateProvider();
  const { control, handleSubmit } = useForm<ProviderFormState>({
    defaultValues: newProvider(),
  });

  const submitProvider = async (state: ProviderFormState) => {
    const { id } = await createProvider(state as unknown as CreateOrUpdateProviderRequest);
    navigate(`/admin/providers/${id}`);
  };

  return (
    <Grid
      container
      spacing={2}
      sx={{
        marginTop: 1,
        marginBottom: 1,
        paddingLeft: 1,
        paddingRight: 1,
      }}
    >
      <ProviderEdit control={control} />
      <Grid
        size={12}
        container
        sx={{
          justifyContent: "flex-end",
        }}
      >
        <Stack direction="row" spacing={2}>
          <CancelButton onClick={() => navigate("/admin/providers")} />
          <AsyncLoadingButton onClick={handleSubmit(submitProvider)}>Zapisz</AsyncLoadingButton>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default NewProviderPage;
